const state = {
    codeRecordList: []
}
const mutations = {
    SET_CODERECORDLIST: (state, cover) => {
        state.codeRecordList = cover
    },
}
export default {
    // 开启命名空间
    namespaced: true,
    mutations,
    state,
}